function LogSummary({ summary }) {
  return (
      <div className="card mt-4 shadow">
        <div className="card-body">
          <h5 className="card-title">Patient Log Summary</h5>
          <p>First Data Point Logged: {summary && summary["start"]}</p>
          <p>Last Data Point Logged: {summary && summary["stop"]}</p>
          <p>Total Data Points Logged: {summary && summary["count"]}</p>
        </div>
      </div>
  );
}

export default LogSummary;
